import { WebAuthnError } from '@simplewebauthn/browser';

const NOT_ALLOWED_ERROR = 'NotAllowedError';

const hasName = (value: unknown, name: string): boolean =>
  typeof value === 'object' && value !== null && (value as { name?: unknown }).name === name;

// Browsers report a dismissed prompt or a timeout as NotAllowedError, which the library wraps as a passthrough.
export const isPasskeyCeremonyCancelled = (error: unknown): boolean =>
  (error instanceof WebAuthnError && error.code === 'ERROR_CEREMONY_ABORTED') ||
  hasName(error, NOT_ALLOWED_ERROR) ||
  (error instanceof WebAuthnError && hasName(error.cause, NOT_ALLOWED_ERROR));
